import React, { Fragment } from 'react'
import Label from '../label/label'
import injectSheet from 'react-jss'
import styles from './accessibility-select.styles'
import ColorSelect from '../../../color-select/color-select'
import {
  accessibilityColors,
  accessibilityColorsList
} from 'pobble-components/dist/presentation'

const colorOptions = accessibilityColorsList.map(id => ({
  color: accessibilityColors[id],
  value: id
}))

const AccessibilitySelect = ({
  classes,
  value = '#FFFFFF',
  onChange,
  onApplyToAll
}) => (
  <Fragment>
    <Label>Accessibility colour</Label>
    <ColorSelect value={value} onChange={onChange} options={colorOptions} />
  </Fragment>
)

export default injectSheet(styles)(AccessibilitySelect)
